import {
  LOGOUT_SYNC_STATIC_PATH,
} from "./logout-sync.constants";

const IFRAME_TIMEOUT_MS = 2500;

/** Purge silencieuse des sessions locales sur chaque module (iframe statique). */
export function syncModuleLogoutIframes(
  moduleBaseUrls: string[],
): Promise<void> {
  if (typeof document === "undefined" || moduleBaseUrls.length === 0) {
    return Promise.resolve();
  }

  const urls = [
    ...new Set(
      moduleBaseUrls
        .map((base) => `${base.replace(/\/$/, "")}${LOGOUT_SYNC_STATIC_PATH}`)
        .filter(Boolean),
    ),
  ];

  return Promise.all(
    urls.map(
      (url) =>
        new Promise<void>((resolve) => {
          const iframe = document.createElement("iframe");
          iframe.setAttribute("aria-hidden", "true");
          iframe.style.cssText =
            "position:absolute;width:0;height:0;border:0;visibility:hidden";
          iframe.src = url;

          const finish = () => {
            if (iframe.dataset.done === "1") return;
            iframe.dataset.done = "1";
            iframe.remove();
            resolve();
          };

          iframe.onload = finish;
          iframe.onerror = finish;
          window.setTimeout(finish, IFRAME_TIMEOUT_MS);
          document.body.appendChild(iframe);
        }),
    ),
  ).then(() => undefined);
}
